export type UnitJurisdiction = 'DLD' | 'DIFC'

const DIFC_LISTING_NOC_CATEGORY = 'DIFC Listing NOC'

export const resolveUnitJurisdiction = (unit: any): UnitJurisdiction =>
    unit?.Jurisdiction === 'DIFC' ? 'DIFC' : 'DLD'

export const getDocumentCategory = (document: any): string => {
    const source = document?.attributes ?? document ?? {}
    return String(source?.Category ?? '').trim()
}

// Category is an API contract here: do not infer a DIFC NOC from its title or type.
export const findDifcListingNoc = (documents: any[]): any | null =>
    documents.find((document) => getDocumentCategory(document) === DIFC_LISTING_NOC_CATEGORY) ?? null

export const hasPublishEndDate = (unit: any): boolean =>
    String(unit?.PublishEndDate ?? '').trim().length > 0

export { DIFC_LISTING_NOC_CATEGORY }
